'use client';

import React, { useState } from 'react';
import DashboardHeader from './DashboardHeader';
import KPIBentoGrid from './KPIBentoGrid';
import OutreachFunnelChart from './OutreachFunnelChart';
import NextBestActions from './NextBestActions';
import TodayTasksList from './TodayTasksList';
import UpcomingMeetings from './UpcomingMeetings';
import PipelineStageBreakdown from './PipelineStageBreakdown';

export default function DashboardContent() {
  const [activeEvent, setActiveEvent] = useState('nra-show-2026');

  return (
    <div className="min-h-screen bg-background">
      <DashboardHeader activeEvent={activeEvent} onEventChange={setActiveEvent} />
      <div className="px-6 xl:px-8 2xl:px-10 pb-10 max-w-screen-2xl mx-auto">
        <KPIBentoGrid />
        <div className="mt-6 grid grid-cols-1 xl:grid-cols-3 gap-6">
          <div className="xl:col-span-2 flex flex-col gap-6">
            <OutreachFunnelChart />
            <PipelineStageBreakdown />
          </div>
          <div className="flex flex-col gap-6">
            <NextBestActions />
            <TodayTasksList />
            <UpcomingMeetings />
          </div>
        </div>
      </div>
    </div>
  );
}